/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const getAgentComparisonMessageStyles = theme => ({
  root: {
    width: '100%',
    mb: 3,
    p: 1.5,
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    bgcolor: theme.validateMode({
      light: 'rgba(15, 23, 42, 0.03)',
      dark: 'rgba(255, 255, 255, 0.04)',
    }),
  },
  titleRow: {
    mb: 1.25,
  },
  columns: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 1.5,
    alignItems: 'stretch',
  },
  column: {
    flex: 1,
    minWidth: 0,
    p: 1.25,
    borderRadius: 1.5,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
  },
  columnHead: {
    mb: 1,
  },
  stats: {
    display: 'block',
    mt: 0.75,
    fontSize: '0.72rem',
    lineHeight: 1.45,
    color: 'text.secondary',
    fontVariantNumeric: 'tabular-nums',
  },
  pending: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
    py: 2,
  },
});
